import { useEffect } from "react"
import { observer } from "mobx-react-lite"
import { useStores, rootStore } from "stores/root-store"
import { storageName } from "shared/constants/storage-constant"
import CommonPage from "components/common/common-page"
import InventoryTable from "./inventory-table"
import { trackEvent } from "utils/analytics"

// Filters shown above the table (item categories). Search term defaults to "%"
// when blank so the page lands with all rows loaded for the selected customer.
const filterData = [
  { name: "item_category1", text: "Item Category 1" },
  { name: "item_category2", text: "Item Category 2" },
  { name: "item_category3", text: "Item Category 3" },
]

const Inventory = () => {
  const { InventoryViewStore } = useStores()

  // If the customer changed since the cache was filled, drop the stale rows so
  // we don't briefly show another customer's data.
  const hasCache = InventoryViewStore.hasCacheForCompany(rootStore.company)

  useEffect(() => {
    rootStore.setOpenForm(false)
    rootStore.setScreenTitle("Inventory")

    if (!hasCache) {
      // Cache is either empty or belongs to a different customer — clear it.
      InventoryViewStore.resetData()
      InventoryViewStore.setCachedForCompany(rootStore.company || "")
    }

    return () => rootStore.setScreenTitle("")
  }, [])

  return (
    <CommonPage
      DataStore={InventoryViewStore}
      filterData={filterData}
      searchPlaceholder="Search for Product code, Description or Cross reference."
      filterStorageName={storageName.inventoryViewFilter}
      extraCustomFilters={{ including_inventory: "Y" }}
      skipAutoSearch={hasCache}
      analyticsEntity="inventory"
      afterLoadingData={() => {
        InventoryViewStore.setCachedForCompany(rootStore.company || "")
        trackEvent("inventory_view", { including_inventory: "Y" })
      }}
      renderGrid={({ data, isLoading, searchText }) => <InventoryTable data={data} isLoading={isLoading} searchText={searchText} />}
    />
  )
}

export default observer(Inventory)
